import { StoreModel } from '@common/models';
import type { RootState } from '@redux/store';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface StoreState {
    selectedStore?: StoreModel;
    prevSelectedStore?: StoreModel;
    restorableStoreId?: number;
}

const initialState: StoreState = {
    selectedStore: undefined,
    prevSelectedStore: undefined,
    restorableStoreId: undefined,
};

const storeSlice = createSlice({
    name: 'store',
    initialState,
    reducers: {
        updateSelectedStore: (state, action: PayloadAction<StoreModel | undefined>) => {
            state.selectedStore = action.payload;
        },
        updatePrevSelectedStore: (state, action: PayloadAction<StoreModel | undefined>) => {
            state.prevSelectedStore = action.payload;
        },
        updateRestorableStoreId: (state, action: PayloadAction<number | undefined>) => {
            state.restorableStoreId = action.payload;
        },
    },
});

export const { updateSelectedStore, updateRestorableStoreId, updatePrevSelectedStore } = storeSlice.actions;

export const selectSelectedStore = ({ store }: RootState): StoreModel | undefined => store.selectedStore;
export const selectPrevSelectedStore = ({ store }: RootState): StoreModel | undefined => store.prevSelectedStore;

export const selectRestorableStoreId = ({ store }: RootState): number | undefined => store.restorableStoreId;

export default storeSlice.reducer;
